import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/core/service/auth.service';

@Injectable({ providedIn: 'root' })
export class CodificationGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const codification: string = route.data['codification'];
    if (!codification) return true;
    if (this.authService.hasAccess(codification)) return true;
    this.router.navigate(['/authentication/signin']);
    return false;
  }
}
